import React from 'react';

export const ProgramDetailsCard = ({
    degreeCertificateLevel,
    creditHourRequirement,
    approvalDate,
    deliveryMode,
    natureOfOnlineProgram,
    programUrl,
}) => (
    <div className="card p-3 mb-3 h-100">
        <h5 className="text-strong mb-3">Program Details</h5>
        <div className="row mb-3">
            <div className="col-md mb-3 mb-md-0">
                <label className="d-block text-muted">Degree/Certificate Level</label>
                <div>{degreeCertificateLevel}</div>
            </div>
        </div>
        <div className="row mb-3">
            <div className="col-md mb-3 mb-md-0">
                <label className="d-block text-muted">Credit Hour Requirement</label>
                <div>{creditHourRequirement}</div>
            </div>
            <div className="col-md">
                <label className="d-block text-muted">Approval Date</label>
                <div>{approvalDate}</div>
            </div>
        </div>
        <div className="row">
            <div className="col-md mb-3 mb-md-0">
                <label className="d-block text-muted">Delivery Mode</label>
                <div>{deliveryMode}</div>
            </div>
            <div className="col-md">
                <label className="d-block text-muted">Nature of Online Program</label>
                <div>{natureOfOnlineProgram}</div>
            </div>
        </div>
        <div className="row mt-3">
            <div className="col-md">
                <label className="d-block text-muted">Program URL</label>
                <div>
                    {programUrl ? (
                        <a href={programUrl} target="_blank" rel="noopener noreferrer">
                            {programUrl}
                        </a>
                    ) : (
                        <span className="text-muted">No URL available</span>
                    )}
                </div>
            </div>
        </div>
    </div>
);
